import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "query",
    "results",
    "parentId",
    "childId",
    "selectedParentLabel",
    "selectedChildLabel"
  ]

  connect() {
    this._abortController = null
     console.log("person-relationships connected")
  }

  disconnect() {
    if (this._abortController) this._abortController.abort()
  }

  search() {
    
    const q = this.queryTarget.value.trim()
    if (q.length < 2) {
      this.resultsTarget.innerHTML = ""
      return
    }

    if (this._abortController) this._abortController.abort()
    this._abortController = new AbortController()

    fetch(`/people/search?q=${encodeURIComponent(q)}`, {
      headers: { "Accept": "application/json" },
      signal: this._abortController.signal
    })
      .then(r => r.json())
      .then(data => this.renderResults(data))
      .catch(err => {
        if (err.name !== "AbortError") console.error(err)
      })
  }

  renderResults(data) {
    this.resultsTarget.innerHTML = ""

    data.forEach(person => {
      const btn = document.createElement("button")
      btn.type = "button"
      btn.className = "list-group-item list-group-item-action"
      // btn.textContent = `${person.label} (${person.birth || ""}–${person.death || ""})`
      const label = person.name || person.label || `Person #${person.id}`
  const dates = person.life_dates || [person.birth, person.death].filter(Boolean).join("–")
  btn.textContent = dates ? `${label} (${dates})` : label
        btn.dataset.personId = person.id
        btn.dataset.personLabel = btn.textContent
        btn.addEventListener("click", () => this.pick(person.id, btn.textContent))
        this.resultsTarget.appendChild(btn)
    })
  }


    pick(id, label) {
      console.log("picked person", id, label)
      console.log("hasParentIdTarget", this.hasParentIdTarget)
      console.log("hasChildIdTarget", this.hasChildIdTarget)
      console.log("hasSelectedParentLabelTarget", this.hasSelectedParentLabelTarget)
      console.log("hasSelectedChildLabelTarget", this.hasSelectedChildLabelTarget)
    // Decide whether we're setting parent or child based on which hidden input exists/enabled.
    // We set BOTH if present, but only the form you submit will matter.
    if (this.hasParentIdTarget) {
      this.parentIdTarget.value = id
      if (this.hasSelectedParentLabelTarget) this.selectedParentLabelTarget.textContent = label
    }
    if (this.hasChildIdTarget) {
      this.childIdTarget.value = id
      if (this.hasSelectedChildLabelTarget) this.selectedChildLabelTarget.textContent = label
    }
  }

    // leave results visible so you can pick again; comment out if you prefer auto-clear:
    // this.resultsTarget.innerHTML = ""


  clear() {
    this.queryTarget.value = ""
    this.resultsTarget.innerHTML = ""
    if (this.hasParentIdTarget) this.parentIdTarget.value = ""
    if (this.hasChildIdTarget) this.childIdTarget.value = ""
    if (this.hasSelectedParentLabelTarget) this.selectedParentLabelTarget.textContent = "None selected"
    if (this.hasSelectedChildLabelTarget) this.selectedChildLabelTarget.textContent = "None selected"
  }
}
